import { ChangeDetectionStrategy, Component, Output, EventEmitter } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'dev-mode',
    templateUrl: './dev-mode.component.html',
    styleUrls: ['./dev-mode.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [provideTranslocoScope('home')],
    imports: [TranslocoModule, MatButtonModule]
})
export class DevModeComponent {
  @Output() close = new EventEmitter();
}
